import { useState } from 'react';
import PropTypes from 'prop-types';

import CourseIncludes from './CourseIncludes/CourseIncludes';
import CourseContent from './CourseContent/CourseContent';
import CourseAditionalMaterial from './CourseAditionalMaterial/CourseAditionalMaterial';
import ReviewsCourse from './ReviewsCourse/ReviewsCourse';

import classes from './CourseBottom.module.css';

const CourseBottom = props => {
  const [showWriteReview, setShowWriteReview] = useState(false);

  const showWriteReviewHandler = () => {
    setShowWriteReview(!showWriteReview);
  };

  return (
    <aside className={classes.courseBottomContainer}>
      <>
        <CourseIncludes
          accessCourse={props.dataCourse.accessCourse}
          ltiData={props.ltiData}
          dataCourse={props.dataCourse}
          lessons={
            props.dataCourse.lessonsCourse.lessonExtraInfo.lessons
              .total
          }
          aditionalMaterial={
            props.dataCourse.lessonsCourse.lessonExtraInfo
              .lessonAdditionalMaterial.additionalMaterial
          }
          activities={
            props.dataCourse.lessonsCourse.lessonExtraInfo
              .lessonActivities.activities
          }
          hrs={
            props.dataCourse.lessonsCourse.lessonExtraInfo.lessons
              .seconds /
            60 /
            60
          }
        />
        <CourseContent
          lessons={props.dataCourse.lessonsCourse}
          accessCourse={props.dataCourse.accessCourse}
          userTrack={props.dataCourse.userAditionalTrack.userTrack}
        />
        {props.dataCourse.data.archivos.length > 0 && (
          <CourseAditionalMaterial
            aditionalMaterial={props.dataCourse.data.archivos}
            accessCourse={props.dataCourse.accessCourse}
          />
        )}
      </>
      {props.dataCourse.aditionalData.reviews === 1 && (
        <ReviewsCourse
          dataCourse={props.dataCourse.data}
          courseReviews={props.dataCourse.courseReviews}
          showWriteReviewHandler={showWriteReviewHandler}
          showWriteReview={showWriteReview}
          accessCourse={props.dataCourse.accessCourse}
        />
      )}
    </aside>
  );
};

CourseBottom.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  ltiData: PropTypes.object
};

export default CourseBottom;
